import { useEffect, useState,useRef } from "react";
import "./App.css";

import { returnMockData, returnRegenerate } from "./Services/mockData";
import apiService from "./Services/apiServices";
import MainChatPage from "./Pages/MainChatPage.js/MainChatPage";
import { baseUrl } from "./Services/urlConfig";
import { ChannelPackDisplay, formatFilterResponse, getFormattedTimestamp, handledButtonsUI } from "./Components/Methods/Methods";
//Testing 1pm

var count = 0;
let globalMessages = [];
let serverData = {};
function App() {
  const [minimized, setMinimize] = useState(false);
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(0);
  const [showMaximumChat, setIsShowMaximumChat] = useState(false);
  const [showMinimizedChat, setShowMinimizedChat] = useState(false);
  const [userDetails, setUserDetails] = useState("");
  const [token, setToken] = useState("");
  const [isShowBot, setIsShowBot] = useState(false);
  const [code, setCode] = useState("");
  const [lastCode, setLastCode] = useState("");
  const [sessionId, setSessionId] = useState(Number);
  const [reLogin , setRelogin] = useState(false)
  const [isSubscriber, setisSubscriber] = useState(true);
  const [showMsgs, setShowMsgs] = useState(false);
  const [disableInputBox , setDisableInputBox] = useState(false);
  const [verifyAgent , setVerifyAgent] = useState(false)
  const [agentGroup , setAgentGroup] = useState(null)
  const [agentType , setAgentType] = useState(null)
  const [flow , setFlow] = useState(null)
  const [agentName , setAgentName] = useState(null)
  const [agentLogID , setAgentLogID] = useState(null)
  const [uniqueId , setUniqueId] = useState(null)
  const [lastInput , setLastInput] = useState(null)
  const [inputArray , setInputArray] = useState([])
  const [codeArray , setCodeArray] = useState([])
  const [checkOfflineButton , setCheckOfflineButton] = useState('')
  const [launchOnButton, setLaunchOnButton] = useState(true)
  const [currentNode , setCurrentNode] = useState('')

 

  const effectRun = useRef(false); // Use ref to track if useEffect has run

    //handleTabClosure event
    // useEffect(() => {
    //   const handleTabClosure = () => {
    //     apiService.loginForRefresh('6').then((res) => {
    //       console.log(res);
    //     });
    //   };
  
    //   window.addEventListener("beforeunload", handleTabClosure);
  
  
    //   return () => {
    //     window.removeEventListener("beforeunload", handleTabClosure);
    //   };
    // }, []);
  
    //handleBackButton event
    // useEffect(() => {
    //   const handleBackButton = () => {
    //     apiService.loginForRefresh('6').then((res) => {
    //       console.log(res);
    //     });
    //   };
  
    //   window.addEventListener("popstate", handleBackButton);
  
    //   return () => {
    //     window.removeEventListener("popstate", handleBackButton);
    //   };
    // }, []);


    async function validateAgent(user) {
  
      const url = `${baseUrl}/cbapi/agentvalidate?user=${user}`;
      
      try {
          const response = await fetch(url, {
              method: 'POST', // Specifying the HTTP method as POST
              headers: {
                "Content-Type": "application/json" // Setting the accept header
              },
              
          });
    
          if (!response.ok) {
              throw new Error(`HTTP error! Status: ${response.status}`);
          }
    
          const data = await response.json();
          console.log("API Response:", data);
          setVerifyAgent(data?.isValidAgent)
          return data?.isValidAgent
      } catch (error) {
          console.error("Error during API call:", error);
          return true
          // throw error; // Re-throwing the error for further handling if needed
      }
    }

  const decode = (encodedStringURI) => {
    if (!encodedStringURI) {
      return null;
    }
    try {
      let decodedStringURI = decodeURIComponent(encodedStringURI);
      let decodedBase64String = atob(decodedStringURI);
      let decodedSurveyConfiguration = JSON.parse(decodedBase64String);
      setAgentGroup(decodedSurveyConfiguration?.agentGroup || '')
      setAgentType(decodedSurveyConfiguration?.agentType || '')
      setAgentName(decodedSurveyConfiguration?.agentName || '')
      setAgentLogID(decodedSurveyConfiguration?.agentLogID || '')
      setUniqueId(decodedSurveyConfiguration?.uniqueId || '')
      setLaunchOnButton(decodedSurveyConfiguration?.launchOnButton || '')
      setUserDetails(decodedSurveyConfiguration?.agentId ||decodedSurveyConfiguration?.userDetails);
      localStorage.setItem(
        "userIdS360",
        decodedSurveyConfiguration?.agentId ||
          decodedSurveyConfiguration?.userDetails ||
          ""
      );
      // sessionStorage.setItem("userIdS360", decodedSurveyConfiguration?.agentId || decodedSurveyConfiguration?.userDetails);
       validateAgent(decodedSurveyConfiguration?.agentId ||decodedSurveyConfiguration?.userDetails)
      return decodedSurveyConfiguration;
    } catch (e) {
      return null;
    }
  };

  useEffect(() => {
    let configEncodedString = ( window.location.search || window.location.pathname || "").substring(
      1,
      ( window.location.search || window.location.pathname || "").length
    );
    let user = decode(configEncodedString);
    sessionStorage.setItem("agenIdS360", user?.agentId);
    function extractTextAfterData(url) {
      const regex = /data=(.*)/;
      const match = url.match(regex);
      return match ? match[1] : "";
    }
    if (!userDetails) {
      let userCode = extractTextAfterData(window.location.href)
      sessionStorage.setItem("userIdS360", userCode);
      userCode !== '' && validateAgent(userCode)
      setUserDetails(userCode);

    }else{
      validateAgent(userDetails)
    }
  }, []);

  useEffect(() => {
    if (showMaximumChat) {
      window.parent.postMessage({ screenMode: "fullScreen" }, "*");
    } else if (showMinimizedChat) {
      window.parent.postMessage({ screenMode: "minimized" }, "*");
    } else if (isShowBot) {
      window.parent.postMessage({ screenMode: "normal" }, "*");
    } else {
      window.parent.postMessage({ screenMode: "icon" }, "*");
    }
  }, [showMaximumChat, showMinimizedChat, isShowBot]);

    useEffect(() => {
      if (effectRun.current) return; // If effect has already run, skip
      effectRun.current = true; // Mark effect as run
    }, []); // Empty array to ensure it runs after the first render


    useEffect(() => {
      const retryTime = sessionStorage.getItem('apiRetryTime');
      const retryData = sessionStorage.getItem('apiRetryData');
    
      if (!retryTime || !retryData) return;
    
      const now = Date.now();
      const parsedData = JSON.parse(retryData);
    
      const executeRetry = async () => {
        try {
          await fetch(`${baseUrl}/cbapi/addErrorMessage?sessionId=${parsedData.sessionId}&errorMessage=${encodeURIComponent("Failed to get a response from the server. Please try again later.")}&bot=agent-assist&nodeId=${parsedData.nodeId}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
          });
    
          sessionStorage.removeItem('apiRetryTime');
          sessionStorage.removeItem('apiRetryData');
    
        } catch (err) {
          console.error("Retry failed again:", err);
        }
      };
    
      if (now >= Number(retryTime)) {
        executeRetry();
      } else {
        const delay = Number(retryTime) - now;
        setTimeout(executeRetry, delay);
      }
    }, []);
  
  

//! API Triggers ---------------------------------------------------------------------------------

  const addMessages = async (msg ,node ,label , displayText ,checkUpdate ,tag ) => { //added check update to decide we need to send code orde update true
    try {
      localStorage.removeItem("inputValue");
      localStorage.removeItem("troubleShooting");
      localStorage.removeItem("inputBoxValue");
      localStorage.removeItem("inputValue1");
      localStorage.removeItem("ignoreError");

      setInputArray([...inputArray , msg])
      setCheckOfflineButton((prev) => '');
      let updatedToken = sessionStorage.getItem("token") ? sessionStorage.getItem("token") : token
      handledButtonsUI()
      const timestamp = getFormattedTimestamp()
      setShowMsgs(true);
      setCount((prevCount) => prevCount + 1);


      if (tag === "A58" ) {
        const filterData = JSON.parse(localStorage.getItem( "selectedLanguagesAndGenres"))?.filterResponse;
        const formattedMessage = formatFilterResponse(filterData);
      
        setMessages((prevMessages) => [
          ...prevMessages,
          {
            text: formattedMessage,
            type: "CUSTOMER",
            date: new Date().toISOString(),
            messageCount: `CUSTOMER-${count + 1}`,
            time: timestamp,
          },
        ]);
      }else if(tag === "A59" || tag === "A63" ){
        // const filterData = JSON.parse(localStorage.getItem("selectedChannelsPAcks"))?.filterResponse;
        const filterData = JSON.parse(msg);
        const formattedMessage = ChannelPackDisplay(filterData);
        setMessages((prevMessages) => [
          ...prevMessages,
          {
            text: formattedMessage,
            type: "CUSTOMER",
            date: new Date().toISOString(),
            messageCount: `CUSTOMER-${count + 1}`,
            time: timestamp,
          },
        ])

      } else if (msg || (label && displayText !== "loader")) {
        const customerMsg = {
          text: displayText ? displayText : msg || label,
          type: "CUSTOMER",
          date: new Date().toISOString(),
          messageCount: `CUSTOMER-${count + 1}`,
          time: timestamp,
        };
      
        setMessages((prevMessages) => [...prevMessages, customerMsg]);
      }

      if (displayText != "loader") {
        setLoading(true);
        // Add a placeholder for the server response with a loading indicator
        const loadingPlaceholder = {
          text: "...",
          type: "SERVER",
          date: new Date().toISOString(),
          messageCount: `SERVER-${count + 1}`,
          isLoading: true,
          time: timestamp,
        };
        setMessages((prevMessages) => [...prevMessages, loadingPlaceholder]);
      }
   
    

    const params = {
      bot: "agent-assist",
      ...(!checkUpdate && node !== "Blank / Transfer / Call Drop" && { code: node === null ? null : node ? node : code }),
      // code: node === null ? null : node ? node : code,
      token: updatedToken,
      ...(msg && {
        // Conditionally add `input` key only if `input` has a truthy value
        input: encodeURIComponent(
          JSON.stringify({
            key1:checkUpdate ? lastInput :  msg,
            key1: msg,
            count: Math.random(),
          })
        ),
      }),
      ...(!msg &&
        msg && {
          // Conditionally add `input` key only if `input` has a truthy value
          input: encodeURIComponent(
            JSON.stringify({
              key1:checkUpdate ? lastInput : msg,
              key1: msg,
              count: Math.random(),
            })
          ),
        }),
      label: encodeURIComponent(
        // Corrected spelling from 'lable' to 'label'
        JSON.stringify({
          key1: label,
          count: Math.random(),
        })
      ),
      ...(node === "Blank / Transfer / Call Drop" && { update: true }),
      ...(checkUpdate && { update: true }),
      // ...(checkUpdate && { input : lastInput }),
      ...(checkUpdate && { code : lastCode }),
      ...(tag==="A3Refresh" && { refresh : true }),
      ...(tag==="MenuButton" && {currentNode : currentNode})
    };
   
    let serverResponse 
    try {
      if (["A58", "A59", "A61", "A63"].includes(tag)) {
        serverResponse = await apiService.inputPostResonse(node ?? code, msg, updatedToken);
      } else {
        serverResponse = await apiService.inputResonse(params);
      }
    } catch (error) {
      let ID = window.sessionStorage.getItem('inputSessionId')
      const retryTime = Date.now() + 5 * 60 * 1000;
      sessionStorage.setItem('apiRetryTime', retryTime);
      sessionStorage.setItem('apiRetryData', JSON.stringify({ sessionId: ID || sessionId, nodeId: node || code, errorMessage: 'Failed to get a response from the server. Please try again later.' }));
      
      const retryApiCall = async () => {
        try {
          await fetch(`${baseUrl}/cbapi/addErrorMessage?sessionId=${ID || sessionId}&errorMessage=${encodeURIComponent("Failed to get a response from the server. Please try again later.")}&bot=agent-assist&nodeId=${node || code}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
          });
          sessionStorage.removeItem('apiRetryTime');
          sessionStorage.removeItem('apiRetryData');
        } catch (e) {
          console.error('Error logging failed, will retry in 5 min:', e);
          const newRetryTime = Date.now() + 5 * 60 * 1000;
          sessionStorage.setItem('apiRetryTime', newRetryTime);
          setTimeout(retryApiCall, 5 * 60 * 1000);
        }
      };
      
      setTimeout(retryApiCall, 5 * 60 * 1000);
      
      const errorMsg = {
        text: "Failed to get a response from the server. Please try again later.",
        type: "SERVER",
        date: new Date().toISOString(),
        messageCount: `SERVER-${count + 1}`,
        isLoading: false,
        isFailed: true,
        time: timestamp
      };
      setMessages((prevMessages) =>
        prevMessages.map((message) => (message.isLoading ? errorMsg : message))
      );
      setLoading(false);
      return;
    }
   

      // Parse the server response

      //!--------- Check for expired session ------------------------------------------------------------------------------
      if (serverResponse?.data?.code === 401) {
        const errorMsg = {
          text: "This session has expired. Please start a new session to continue.",
          type: "SERVER",
          date: new Date().toISOString(),
          messageCount: `SERVER-${count + 1}`,
          isLoading: false,
          isFailed: true,
          time: timestamp,
        };

        setMessages((prevMessages) =>
          prevMessages.map((message) => (message.isLoading ? errorMsg : message))
        );
        setLoading(false);
        return;
      }

      //!--------- Check for server response code 400--------------------------------------------------------------------------------------

    //   if (serverResponse?.data?.code === 400 && serverResponse?.data?.message === "Invalid token") {
    //   const errorMsg = {
    //     text: "Too Many user trying to logged in, Please try again",
    //     type: "SERVER",
    //     date: new Date().toISOString(),
    //     messageCount: `SERVER-${count + 1}`,
    //     isLoading: false,
    //     isFailed: true,
    //     time : timestamp
    //   };

    //   // Replace the loading placeholder with the error message
    //   setMessages((prevMessages) =>
    //     prevMessages.map((message) => (message.isLoading ? errorMsg : message))
    //   );
    //   setLoading(false);
    //   return;
    // }

    
    //!--------- Check for server response code 200 -------------------------------------------------------------------------------------------

    if (!serverResponse?.data?.chatResponse || serverResponse?.data?.chatResponse?.entries?.length === 0) {
      let ID = window.sessionStorage.getItem('inputSessionId')
      const retryTime = Date.now() + 5 * 60 * 1000;
      sessionStorage.setItem('apiRetryTime', retryTime);
      sessionStorage.setItem('apiRetryData', JSON.stringify({ sessionId: ID || sessionId, nodeId: node || code, errorMessage: 'Failed to get a response from the server. Please try again later.' }));
      
      const retryApiCall = async () => {
        try {
          await fetch(`${baseUrl}/cbapi/addErrorMessage?sessionId=${ID || sessionId}&errorMessage=${encodeURIComponent("Failed to get a response from the server. Please try again later.")}&bot=agent-assist&nodeId=${node || code}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
          });
          sessionStorage.removeItem('apiRetryTime');
          sessionStorage.removeItem('apiRetryData');
        } catch (e) {
          console.error('Error logging failed, will retry in 5 min:', e);
          const newRetryTime = Date.now() + 5 * 60 * 1000;
          sessionStorage.setItem('apiRetryTime', newRetryTime);
          setTimeout(retryApiCall, 5 * 60 * 1000);
        }
      };
      
      setTimeout(retryApiCall, 5 * 60 * 1000);
      
      const errorMsg = {
        text: "Failed to get a response from the server. Please try again later.",
        type: "SERVER",
        date: new Date().toISOString(),
        messageCount: `SERVER-${count + 1}`,
        isLoading: false,
        isFailed: true,
        time : timestamp
      };

      setMessages((prevMessages) =>
        prevMessages.map((message) => (message.isLoading ? errorMsg : message))
      );
      setLoading(false);
      return;
    }
      let data = serverResponse?.data?.chatResponse;
      if(serverResponse?.data?.sessionId){
        sessionStorage.setItem("inputSessionId", JSON.stringify(serverResponse?.data?.sessionId));
      }
      
      setFlow(data?.flow || null)
      const bypassFlows = [
        'ByPassIntent Call Disrupt',
        'ByPassIntent Blank Call',
        'ByPassIntent Call Drop',
        'ByPassIntent Call Transfer',
      ];
      console.log("bypassFlows", bypassFlows, data?.flow, bypassFlows.includes(data?.flow));
      if (bypassFlows.includes(data?.flow)) {
        setCodeArray([...codeArray, node || code]);
      } else {
      // if(data?.flow === 'Call Disrupt'){
      //   setCodeArray([...codeArray , node || code])
      // }
      // if(data?.flow  !== 'Call Disrupt'){
        setLastCode(params?.code);
      }

      if(node === 'Blank / Transfer / Call Drop'){
        setLastInput((prev) => inputArray[inputArray.length - 1]);   
      }

      let serverData = {};

      if (data?.entries.length > 0) {
        serverData.entries = data?.entries
        serverData.type = "SERVER";
        serverData.messageCount = `SERVER-${count + 1}`;
        serverData.time = timestamp
        serverData.viewMenuInfo = data?.viewMenuInfo || null
        serverData.end = data?.end || false
        setLoading(false);
        const entryA3 = data?.entries?.find(
            (item) => item.uiCommand === "A3"
          );

        if (entryA3) {
          var parseData = (() => {
            try {
              return JSON.parse(entryA3?.text);
            } catch (e) {
              return entryA3?.text;
            }
          })();
        }
        if(parseData === 'Start'){
          return
        }
        // if (!sessionId) {
          setSessionId(Number(parseData?.session_id));
        // }
        
        if (data?.entries?.some((el) => el?.uiCommand === "A14")) {
          const entryA14 = data?.entries?.find(
            (item) => item.uiCommand === "A14"
          );
          setCode(entryA14?.code);
        }
      }
      const entryA3f = data?.entries?.find(
        (item) => item.uiCommand === "A3f"
      );
      setDisableInputBox(!data?.enableDefaultTextBox)
      setCurrentNode(data?.currentOpCode)
     
      // if (
      //   data?.entries?.some((el) => el?.uiCommand === "A1" || el?.uiCommand === "A15"  || el?.uiCommand === "A1i"  )
      // ) {
      //   setDisableInputBox(true)
      // }else{
      //   setDisableInputBox(false)
      // }

      //!--------- Check for server response endchat----------------------------------------------------------------------------------------------
      if(data?.end){
        setCheckOfflineButton((prev) => 'end');
      }
      // if (data?.end && !entryA3f) {
      //   serverData = {
      //     text: "Failed to get a response from the server. Please try again later.",
      //     type: "ERROR",
      //     date: new Date().toISOString(),
      //     messageCount: `ERROR-${count + 1}`,
      //     isLoading: false,
      //     isFailed: true,
      //     time : timestamp
      //   };
      //   serverData.type = "SERVER";
      //   serverData.messageCount = `SERVER-${count + 1}`;
      //   // setRelogin(true)
      //   setLoading(false);

      // }

      if(displayText === "loader"){
        setMessages((prevState) => {
          const updatedNames = [...prevState];
      
          const splitIndexes = serverData?.entries
            ?.map((item, index) => (item.uiCommand === "A1break" ? index : -1))
            ?.filter((index) => index !== -1);
      
          if (splitIndexes?.length > 0) {
            const splitArrays = [];
            let start = 0;
      
            splitIndexes.forEach((splitIndex) => {
              splitArrays.push(serverData.entries.slice(start, splitIndex));
              start = splitIndex;
            });
      
            splitArrays.push(serverData.entries.slice(start));
      
            const splitServerData = splitArrays.map((entries) => ({
              ...serverData,
              entries,
            }));
      
            // replace last element if it's loader
            updatedNames.pop();
            updatedNames.push(...splitServerData);
            return updatedNames;
          } else {
            // normal single replacement (no A1break)
            updatedNames[updatedNames.length - 1] = serverData;
            return updatedNames;
          }
        });
      }
      else{
        setMessages((prevMessages) => {
          const splitIndexes = serverData?.entries
              ?.map((item, index) => item.uiCommand === "A1break" ? index : -1)
              ?.filter(index => index !== -1); 
          if (splitIndexes?.length > 0) {
              const splitArrays = [];
              let start = 0;
              
              splitIndexes.forEach((splitIndex) => {
                  splitArrays.push(serverData.entries.slice(start, splitIndex)); 
                  start = splitIndex; 
              });
            
              splitArrays.push(serverData.entries.slice(start));
         
              const splitServerData = splitArrays.map(entries => ({
                  ...serverData,
                  entries
              }));

              return prevMessages.reduce((acc, message) => {
                  if (message.isLoading) {
                      acc.push(...splitServerData); 
                  } else {
                      acc.push(message); 
                  }
                  return acc;
              }, []);
          } else {
              return prevMessages.map((message) =>
                  message.isLoading ? serverData : message
              );
          }
      });
    }
      
      setLoading(false);

    //!--------- Error catch----------------------------------------------------------------------------------------------

    } catch (error) {
      console.error("Error adding messages:", error);
      const isSessionExpired = error?.response?.status === 401;
      const timestamp = new Date().toLocaleString('en-IN', {
        // weekday: 'short', // Change 'long' to 'short' for abbreviated day names
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        // second: '2-digit',
        hour12: true // Use 12-hour clock format (pm/am)
    }).replace(' at ', ', ');

      // Show an error message in the chat
      const errorMsg = {
        text: isSessionExpired
          ? "This session has expired. Please create a new session."
          : "Failed to get a response from the server. Please try again later.",
        type: "SERVER",
        date: new Date().toISOString(),
        messageCount: `SERVER-${count + 1}`,
        isLoading: false,
        isFailed: true,
        time : timestamp
      };

      // Replace the loading placeholder with the error message
      setMessages((prevMessages) =>
        prevMessages.map((message) => (message.isLoading ? errorMsg : message))
      );
      setLoading(false);
    }
  };


  //! Feedback API/funtion Triggers ---------------------------------------------------------------------------------

  const updateThumbsIcon = (key) => {
    if (!["thumbsUp", "thumbsDown"].includes(key)) return; // Ensure valid key
  
    const updatedMessage = [...messages]; // Create a copy of the state
  
    // Find the last message that contains "entries"
    const lastMessageWithEntries = updatedMessage
      .slice()
      .reverse()
      .find((msg) => msg.entries);
  
    // If such a message exists, update its last entry
    if (lastMessageWithEntries) {
      const lastEntryIndex = lastMessageWithEntries.entries.length - 1;
      lastMessageWithEntries.entries[lastEntryIndex] = {
        ...lastMessageWithEntries.entries[lastEntryIndex], // Keep existing properties
        [key]: true, // Dynamically set either thumbsUp or thumbsDown
      };
    }
  
    // Update the state with the modified message
    setMessages(updatedMessage);
  };

  const addMessagesFeedback = async (msg ,node ,label,input , inputText ,body ) => {
    
    try {
      setCheckOfflineButton((prev) => '');
       {updateThumbsIcon(msg === 'Thumbs Up' ? 'thumbsUp' : "thumbsDown")}
      localStorage.removeItem("ignoreError");
      localStorage.removeItem("inputValue");
      let updatedToken = sessionStorage.getItem("token") ? sessionStorage.getItem("token") : token
      let n = document.getElementsByClassName("action-tab");

      for (let i = 0; i < n.length; i++) {
        n[i].disabled = true;
        n[i].style.cursor = "not-allowed";
        // n[i].style.opacity = 0.5;
        n[i].style.pointerEvents = "none";
      }

      let ob = document.getElementsByClassName("option-button")

      for (let i = 0; i < ob.length; i++) {
        ob[i].disabled = true;
        ob[i].style.cursor = "not-allowed";
        // n[i].style.opacity = 0.5;
        ob[i].style.pointerEvents = "none";
      }

      let button = document.getElementsByClassName("a1-wrap");

      for (let i = 0; i < button?.length; i++) {
        button[i].style.cursor = "not-allowed"; 
        // Optional styles if needed:
        // button[i].style.pointerEvents = "none";
      }

      let inputs = document.getElementsByClassName("form-control");

      for (let i = 0; i < inputs?.length; i++) {
        inputs[i].style.cursor = "not-allowed"; // Set cursor style
        inputs[i].disabled = true; // Disable input elements
        // Optional styles if needed:
        // elements[i].style.opacity = "0.5";
        // elements[i].style.pointerEvents = "none";
      }
      
      
      const timestamp = new Date().toLocaleString('en-IN', {
        // weekday: 'short', // Change 'long' to 'short' for abbreviated day names
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        // second: '2-digit',
        hour12: true // Use 12-hour clock format (pm/am)
    }).replace(' at ', ', ');

      setShowMsgs(true);
      setCount((prevCount) => prevCount + 1);
      if(msg || label && inputText != "loader"){

        const customerMsg = {
          text: inputText ? inputText : msg || label,
          type: "CUSTOMER",
          date: new Date().toISOString(),
          messageCount: `CUSTOMER-${count + 1}`,
          time : timestamp
        };
        setMessages((prevMessages) => [...prevMessages, customerMsg]);
      }

     if(inputText != "loader")
      { 
        setLoading(true);
      // Add a placeholder for the server response with a loading indicator
      const loadingPlaceholder = {
        text: "...",
        type: "SERVER",
        date: new Date().toISOString(),
        messageCount: `SERVER-${count + 1}`,
        isLoading: true,
        time : timestamp
      };
      setMessages((prevMessages) => [...prevMessages, loadingPlaceholder]);
    }


      const params = {
        bot: "agent-assist",
        code: node === null ? null : (node ? node : code),
        token: updatedToken,
        label: encodeURIComponent( // Corrected spelling from 'lable' to 'label'
            JSON.stringify({
                key1: label,
                count: Math.random(),
            })
        ),
    };
    
      // Simulate API call to retrieve server response
      let serverResponse = await apiService.inputResonsePostPacks(params , body);

      // Parse the server response

      // let res = JSON.parse(serverResponse);
       // Check the server response code

      // if (serverResponse?.data?.code === 400 && serverResponse?.data?.message === "Invalid token") {
      // const errorMsg = {
      //   text: "Too Many user trying to logged in, Please try again",
      //   type: "SERVER",
      //   date: new Date().toISOString(),
      //   messageCount: `SERVER-${count + 1}`,
      //   isLoading: false,
      //   isFailed: true,
      //   time : timestamp
      // };

      // Replace the loading placeholder with the error message
    //   setMessages((prevMessages) =>
    //     prevMessages.map((message) => (message.isLoading ? errorMsg : message))
    //   );
    //   setLoading(false);
    //   return;
    // }
    
    // if (serverResponse?.data?.code !== 200) {
    //   const errorMsg = {
    //     text: "Failed to get a response from the server. Please try again later.",
    //     type: "SERVER",
    //     date: new Date().toISOString(),
    //     messageCount: `SERVER-${count + 1}`,
    //     isLoading: false,
    //     isFailed: true,
    //     time : timestamp
    //   };

    //   // Replace the loading placeholder with the error message
    //   setMessages((prevMessages) =>
    //     prevMessages.map((message) => (message.isLoading ? errorMsg : message))
    //   );
    //   setLoading(false);
    //   return;
    // }
      let data = serverResponse?.data?.chatResponse;
      if(data?.entries.length === 0){

      }
      setFlow(data?.flow || null)

      let serverData = {};

      if (data?.entries.length > 0) {
        serverData.entries = data?.entries
        serverData.type = "SERVER";
        serverData.messageCount = `SERVER-${count + 1}`;
        serverData.time = timestamp
        setLoading(false);
        const entryA3 = data?.entries?.find(
            (item) => item.uiCommand === "A3"
          );

        if (entryA3) {
          var parseData = (() => {
            try {
              return JSON.parse(entryA3?.text);
            } catch (e) {
              return entryA3?.text;
            }
          })();
        }
        if(parseData === 'Start'){
          return
        }
        // if (!sessionId) {
          setSessionId(Number(parseData?.session_id));
        // }
        
        if (data?.entries?.some((el) => el?.uiCommand === "A14")) {
          const entryA14 = data?.entries?.find(
            (item) => item.uiCommand === "A14"
          );
          setCode(entryA14?.code);
        }
      }
      const entryA3f = data?.entries?.find(
        (item) => item.uiCommand === "A3f"
      );
      setDisableInputBox(!data?.enableDefaultTextBox)
     
      // if (
      //   data?.entries?.some((el) => el?.uiCommand === "A1" || el?.uiCommand === "A15"  || el?.uiCommand === "A1i"  )
      // ) {
      //   setDisableInputBox(true)
      // }else{
      //   setDisableInputBox(false)
      // }

      if(data?.end){
        setCheckOfflineButton((prev) => 'end');
      }
      if (data?.end && !entryA3f) {
        serverData = {
          text: "Failed to get a response from the server. Please try again later.",
          type: "ERROR",
          date: new Date().toISOString(),
          messageCount: `ERROR-${count + 1}`,
          isLoading: false,
          isFailed: true,
          time : timestamp
        };
        serverData.type = "SERVER";
        serverData.messageCount = `SERVER-${count + 1}`;
        setRelogin(true)
        setLoading(false);
      }

      if(inputText === "loader"){
        setMessages((prevState) => {
          const updatedNames = [...prevState];
          updatedNames[updatedNames.length - 1] = serverData;
          return updatedNames;
        });
      }
      else{
        setMessages((prevMessages) =>
          prevMessages.map((message) =>
            message.isLoading ? serverData : message
          )
        );
    }
      
      setLoading(false);
    } catch (error) {
      console.error("Error adding messages:", error);
      const timestamp = new Date().toLocaleString('en-IN', {
        // weekday: 'short', // Change 'long' to 'short' for abbreviated day names
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        // second: '2-digit',
        hour12: true // Use 12-hour clock format (pm/am)
    }).replace(' at ', ', ');

      // Show an error message in the chat
      const errorMsg = {
        text: "Failed to get a response from the server. Please try again later.",
        type: "SERVER",
        date: new Date().toISOString(),
        messageCount: `SERVER-${count + 1}`,
        isLoading: false,
        isFailed: true,
        time : timestamp
      };

      // Replace the loading placeholder with the error message
      setMessages((prevMessages) =>
        prevMessages.map((message) => (message.isLoading ? errorMsg : message))
      );
      setLoading(false);
    }
  };
  



  //! Regerate API Triggers ---------------------------------------------------------------------------------

  const updateMessage = async (msgBody) => {
    console.log(msgBody);
    setCheckOfflineButton((prev) => '');
    // Find message by id i.e messageCount
    //call api to update message
    let tempMsgBody = msgBody;
    delete tempMsgBody.messageCount;
    delete tempMsgBody.llm_response;
    delete tempMsgBody.type;
    tempMsgBody.offset = 5;
    tempMsgBody.temperature = 0.1;
    const timestamp = new Date().toLocaleString('en-IN', {
      // weekday: 'short', // Change 'long' to 'short' for abbreviated day names
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      // second: '2-digit',
      hour12: true // Use 12-hour clock format (pm/am)
  }).replace(' at ', ', ');

    try {
      setLoading(true);
      // Add a placeholder for the server response with a loading indicator
      const loadingPlaceholder = {
        text: "...",
        type: "SERVER",
        date: new Date().toISOString(),
        messageCount: `SERVER-${count + 1}`,
        isLoading: true,
        time : timestamp
      };
      setMessages((prevMessages) => {
        const updatedNames = [...prevMessages];
        updatedNames[updatedNames.length - 1] = loadingPlaceholder;
        return updatedNames;
      });

      let serverResponse = await apiService.inputResonse({
        // input: encodeURIComponent(
        //   JSON.stringify({
        //     key1: msgBody,
        //     count: Math.random(),
        //   })
        // ),
        token: token,
        bot: "agent-assist",
        code: code,
        refresh: true,
      });

            // Check the server response code
      if (serverResponse?.data?.code !== 200) {
        const errorMsg = {
          text: "Failed to get a response from the server. Please try again later.",
          type: "SERVER",
          date: new Date().toISOString(),
          messageCount: `SERVER-${count + 1}`,
          isLoading: false,
          isFailed: true,
          time : timestamp
        };

        // Replace the loading placeholder with the error message
        setMessages((prevMessages) => {
          const updatedMessages = [...prevMessages];
          updatedMessages[updatedMessages.length - 1] = errorMsg;
          return updatedMessages;
        });
        setLoading(false);
        return;
      }
      let data = serverResponse?.data?.chatResponse;
      setFlow(data?.flow || null)

      let serverData = {};
      if (data?.entries?.length > 0) {
        serverData.entries = data?.entries
        serverData.type = "SERVER";
        serverData.messageCount = `SERVER-${count + 1}`;
        serverData.time = timestamp
        setLoading(false);
        const entryA3 = data?.entries?.find(
            (item) => item.uiCommand === "A3"
          );

        if (entryA3) {
          var parseData = (() => {
            try {
              return JSON.parse(entryA3?.text);
            } catch (e) {
              return entryA3?.text;
            }
          })();
        }
        // if (!sessionId) {
          setSessionId(Number(parseData?.session_id));
        // }


        if (data?.entries?.some((el) => el?.uiCommand === "A14")) {
          const entryA14 = data?.entries?.find(
            (item) => item.uiCommand === "A14"
          );
          setCode(entryA14?.code);
        }
      }

      if (data?.end) {
        serverData = {
          text: "Failed to get a response from the server. Please try again later.",
          type: "ERROR",
          date: new Date().toISOString(),
          messageCount: `ERROR-${count + 1}`,
          isLoading: false,
          isFailed: true,
          time : timestamp
        };
        serverData.type = "SERVER";
        serverData.messageCount = `SERVER-${count + 1}`;
        setRelogin(true)
        setLoading(false);

      }

      setMessages((prevState) => {
        const updatedNames = [...prevState];
        updatedNames[updatedNames.length - 1] = serverData;
        return updatedNames;
      });
      setLoading(false);
    } catch (error) {
      console.error("Error adding messages:", error);
      // Handle errors here
    }
  };
  const clearMessages = () => {
    setMessages([]);
  };
  useEffect(() => {
    console.log(messages);
  }, [messages]);

  return (
    <div className="App">
      <MainChatPage
        minimized={minimized}
        messages={messages}
        addMessages={addMessages}
        clearMessages={clearMessages}
        loading={loading}
        updateMessage={updateMessage}
        showMaximumChat={showMaximumChat}
        setIsShowMaximumChat={setIsShowMaximumChat}
        showMinimizedChat={showMinimizedChat}
        setShowMinimizedChat={setShowMinimizedChat}
        userDetails={userDetails}
        setToken={setToken}
        isShowBot={isShowBot}
        setIsShowBot={setIsShowBot}
        setCode={setCode}
        token={token}
        sessionId={sessionId}
        reLogin={reLogin}
        setRelogin={setRelogin}
        setisSubscriber={setisSubscriber}
        isSubscriber={isSubscriber}
        showMsgs={showMsgs}
        setShowMsgs={setShowMsgs}
        setDisableInputBox={setDisableInputBox}
        disableInputBox={disableInputBox}
        verifyAgent={verifyAgent}
        agentGroup={agentGroup}
        agentType={agentType}
        addMessagesFeedback ={addMessagesFeedback }
        agentName={agentName}
        agentLogID={agentLogID}
        flow={flow}
        uniqueId={uniqueId}
        lastCode={lastCode}
        lastInput={lastInput}
        checkOfflineButton={checkOfflineButton}
        launchOnButton={launchOnButton}

      />
    </div>
  );
}

export default App;
